/**
 * Mega Menu Hover Behavior
 * Opens/closes mega menu on hover instead of click
 */

class MegaMenuHover {
  constructor() {
    this.menus = document.querySelectorAll('.mega-menu');
    this.closeTimeout = null;
    this.init();
  }

  init() {
    this.menus.forEach((menu) => {
      const details = menu;
      const summary = menu.querySelector('summary');

      // Prevent default click behavior on summary
      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });

      // Open on mouse enter
      menu.addEventListener('mouseenter', () => {
        this.clearCloseTimeout();
        this.openMenu(details);
      });

      // Close on mouse leave (with delay)
      menu.addEventListener('mouseleave', () => {
        this.scheduleClose(details);
      });

      // Keep open on focus within (for keyboard navigation)
      menu.addEventListener('focusin', () => {
        this.clearCloseTimeout();
        this.openMenu(details);
      });
    });
  }

  openMenu(details) {
    if (!details.hasAttribute('open')) {
      details.setAttribute('open', '');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    }
  }

  closeMenu(details) {
    if (details.hasAttribute('open')) {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  }

  scheduleClose(details) {
    this.clearCloseTimeout();
    this.closeTimeout = setTimeout(() => {
      this.closeMenu(details);
    }, 150); // Small delay to allow moving to submenu
  }

  clearCloseTimeout() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MegaMenuHover());
} else {
  new MegaMenuHover();
}

